import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import {UploadImage} from 'components/UI/Image';

class BusinessForwardChoosedItem extends Component {
  constructor(props) {
    super(props);
    this.handleRemove = this.handleRemove.bind(this);
  }

  static propTypes = {
    onRemove: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
  }

  handleRemove = () => {
    if (!this.props.data || !this.props.data.id) {
      return;
    }
    this.props.onRemove && this.props.onRemove(this.props.data.id);
  }

  render() {
    const { data, index } = this.props;
    if (!data) {
      return null;
    }

    let Img = null;
    if (this.props.data.logo) {
      Img = <UploadImage width={80} height={80} type='BUSINESS' image={this.props.data.logo} transform='crop'/>
    } else {
      Img = <img src={require('assets/images/placeholder-128.jpg')} alt="..." width="100" height="100"/>;
    }

    return (
      <tr className="tr">
        <td className="td col-lg-1">
          {index}
        </td>
        <td className="td col-lg-10">
        <div className="business-info">
          <div className="box-image">
            {Img}
          </div>
          <div className="box-content">
            <p className="box-text">
              <span className="text">{data.name}</span>
            </p>
            <p className="box-text">
              <span className="title">SĐT:&nbsp;</span>
              <span className="text">{data.phone}</span>
            </p>
            <p className="box-text">
              <span className="title">Email:&nbsp;</span>
              <span className="text">{data.email}</span>
            </p>
          </div>
        </div>
        </td>
        <td className="td col-lg-2 text-center">
          <button className="btn btn-warning" type="button" onClick={this.handleRemove}>Gỡ</button>
        </td>
      </tr>
    );
  }
}

export default BusinessForwardChoosedItem;


// WEBPACK FOOTER //
// ./components/business/BusinessForwardChoosedItem.jsx